<!-- 首页 -->
<template>
  <div class="home-index">
    <div class="top_banner">
      <img @click="toSearch" src="../../assets/input_bg.png" alt="" />
    </div>
    <!-- <van-tabs
      v-model:active="active"
      @click-tab="onClickTab"
      shrink
      color="#1890FF"
      title-active-color="#1890FF"
      line-width="18px"
    >
      <van-tab
        v-for="(item1, index1) in dataList"
        :key="index1"
        :title="item1.name"
      > -->
        <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <div class="data-item" v-for="(item, index) in dataArry" :key="index">
            <div class="data-item-div1" @click="toDetails(item)">
              <img v-show="item.img" :src="item.img" alt="" />
              <div class="data-item-div1-test">
                <h4>{{ item.name }}</h4>
                <div>{{ item.adder }}</div>
              </div>
            </div>
            <div class="data-item-div2">
              <div>营业时间：{{ item.openTime }}</div>
              <a :href="`tel:` + item.tel"></a>
            </div>
          </div>
        </van-list>
      <!-- </van-tab>
    </van-tabs> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "",
      dataList: [
        {
          name: "全部",
        },
        // {
        //   name: "分类名称",
        // },
        // {
        //   name: "分类名称",
        // },
      ],
      loading: false,
      finished: true,
      dataArry: [
        {
          img: "",
          name: "春田蜜蜜幼幼园",
          adder: "柳州市桂中大道南端2号阳光一百城市广场18栋2楼2-1",
          tel: "15078501559",
          openTime: "8:00-18:00",
          info: "",
        },
        {
          img: "",
          name: "凡恩托育中心",
          adder: "柳州市滨江东路16号金沙角一区2-1-1",
          tel: "13297892101",
          openTime: "8:00-18:00",
          info: "",
        },
        {
          img: "",
          name: "爱德哈贝托育园",
          adder: "柳州市学院路50号鑫中联大厦写字楼2栋1-1",
          tel: "13557628591",
          openTime: "8:00-18:00",
          info: "",
        },
        {
          img: "",
          name: "哈贝托育园",
          adder: "城中区东环路145号",
          tel: "1827688926",
          openTime: "8:00-18:00",
          info: "",
        },
        {
          img: "",
          name: "新华幼儿托育园",
          adder: "柳州市桂中大道阳光壹佰城市广场8栋二层",
          tel: "19142828118",
          openTime: "8:00-18:00",
          info: "",
        },
        {
          img: "",
          name: "BB Family托育园",
          adder: "柳州市城中区东郡鼎苑25栋商铺二楼",
          tel: "15807724086",
          openTime: "8:00-18:00",
          info: "",
        },
        {
          img: "",
          name: "婴为有你幼幼园",
          adder: "大城小院43-2-101.102",
          tel: "13707728845",
          openTime: "8:00-18:00",
          info: "",
        },
        {
          img: "",
          name: "柳州市赐安托育有限公司荣和分公司（团团糯婴幼儿成长中心）",
          adder: "柳州市城中区沿江路28号荣和天誉15栋1-32至35号",
          tel: "18977226625",
          openTime: "8:00-18:00",
          info: "",
        },
      ],
    };
  },

  activated() {},

  created() {
    document.title = "城中区在业托育机构名单";

    if (this.$eshimin) {
      this.$eshimin.setTitle({
        title: "城中区在业托育机构名单",
        onResponse: function (res) {
          console.log("setTitle res:" + res);
        },
      });
    }
  },

  mounted() {},

  methods: {
    onClickTab() {},
    onLoad() {},
    toDetails(item) {
      console.log("详情", item);
      sessionStorage.setItem("czServiceInfo", JSON.stringify(item));
      this.$router.push("/czServiceInfo");
    },
    toSearch() {
      sessionStorage.setItem(
        "czService_dataArry",
        JSON.stringify(this.dataArry)
      );
      this.$router.push("/czSearch");
    },
  },

  filters: {},

  watch: {},

  //离开路由，不可截停
  destroyed() {},

  //离开路由，可截停
  beforeRouteLeave(to, from, next) {
    next();
  },
};
</script>

<style lang="less" scoped>
//显示一行，超出省略号
.show-text-1 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
//显示多行，超出省略号
.show-text-num(@num) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: @num;
  overflow: hidden;
  word-break: break-all;
}
// 抛弃行高，文字居中写法全居中
.all_center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-index {
  height: 100%;
  width: 100%;
  font-size: 0;
  background: #f4f6f8;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.top_banner {
  padding: 13px 15px;
  background: #fff;
  img {
    width: 100%;
  }
}
/deep/ .van-tabs__content {
  padding: 0 15px;
  overflow-y: auto;
  height: calc(100vh - 120px);
  margin-top: 15px;
}
/deep/ .van-tabs__nav {
  padding: 0 15px 15px 15px;
}
/deep/ .van-tab {
  flex: inherit;
  margin-right: 20px;
}
.data-item {
  font-size: 20px;
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  margin: 10px 0;
  .data-item-div1 {
    display: flex;
    img {
      width: 62px;
      height: 62px;
      margin-right: 10px;
    }
    .data-item-div1-test {
      width: calc(100% - 72px);
      h4 {
        color: #333;
        font-size: 16px;
        height: 22.5px;
        font-weight: 600;
        .show-text-1;
      }
      div {
        font-size: 13px;
        color: #999;
        margin-top: 3px;
        line-height: 18px;
      }
    }
  }
  .data-item-div2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    div {
      color: #333;
      font-size: 13px;
    }
    a {
      display: inline-block;
      width: 102px;
      height: 30px;
      background: url("../../assets/tel_btn.png");
      background-size: 100% 100%;
    }
  }
}
.van-list{
  height: calc(100% - 61px);
  overflow:auto;
  padding:0 15px;
}
</style>